import { usePermission } from "app/hooks/usePermission";
import { PermissionLevel } from "app/zustand/assistantPermissionsStore";

export function useProposalLockLevel(): PermissionLevel {
  const { level: proposalsLevel } = usePermission("PIPELINE.PROPOSALS");

  return proposalsLevel;
}

export default useProposalLockLevel;
